import { render, staticRenderFns } from "./WhatsAppTemplatePicker.vue?vue&type=template&id=4a7dc15e&scoped=true"
import script from "./WhatsAppTemplatePicker.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppTemplatePicker.vue?vue&type=style&index=0&id=4a7dc15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7dc15e",
  null
  
)

export default component.exports